// extracted by mini-css-extract-plugin
export default {"button":"Buttons_button__3+iTW"};